export const CARRIER_LIST = '/api/metadata/all-carriers';
export const PROCESSOR_LIST = '/api/metadata/regions?includeCarriers=true';
export const UPDATE_CARRIERS_TO_PROCESSOR = '/api/metadata/region/{regionId}';
